<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="operators"
      :loading="loading"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer
      no-data-text="Нет зарегестрированных сотрудников"
      loading-text="Загрузка списка сотрудников"
      style="border-bottom: 1px solid #e0e0e0;"
    >
      <template v-slot:item="{ item, index }">
        <tr style="height: 60px">
          <td>{{ index + 1 }}</td>
          <td class="py-2">
            <div class="cell-text cell-text-bold">{{ item.organizationInn }}</div>
            <div class="cell-text cell-text-normal">{{ item.organizationName }}</div>
          </td>
          <td class="py-2">
            <div class=" cell-text cell-text-bold">{{ item.personalInn }}</div>
            <div class=" cell-text cell-text-normal">{{ item.fullName }}</div>
          </td>
          <td>{{ displayRole(item.role) }}</td>
          <td>
            <span class="cell-text cell-text-link" @click.prevent="clickHandler(item)">Заблокировать</span>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-6">
      <v-pagination v-model="page" :length="countPages" total-visible="12" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataTable',
  props: {
    operators: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    roles: {
      REGISTRAR: 'registrar',
      ADMIN: 'admin',
      SUPER_ADMIN: 'super_admin',
      ADMIN_SIGN: 'admin_sign',
      REGISTRAR_SIGN: 'registrar_sign'
    },
    headers: [
      { text: '№', sortable: false },
      { text: 'Организация', align: 'left', value: 'inn', sortable: false },
      { text: 'Сотрудник', align: 'left', value: 'fullName', sortable: false },
      { text: 'Должность', sortable: false },
      { text: 'Действие', sortable: false }
    ],
    page: 1,
    itemsPerPage: 10
  }),
  watch: {
    page(val) {
      this.$store.dispatch(
        'GET_OPERATORS_LIST',
        this.searchValue
          ? { innFilter: this.searchValue, nameFilter: this.searchValue, amount: this.itemsPerPage, page: val }
          : { amount: this.itemsPerPage, page: val }
      )
    }
  },
  computed: {
    loading() {
      return this.$store.state.registrars.loading.getRegistrars
    },
    total() {
      return this.$store.state.registrars.total
    },
    countPages() {
      return Math.ceil(this.total / this.itemsPerPage)
    },
    searchValue() {
      return this.$store.state.subscribers.searchValue
    }
  },
  methods: {
    displayRole(role) {
      switch (role) {
        case this.roles.SUPER_ADMIN:
          return 'Супер-администратор'
        case this.roles.ADMIN:
          return 'Администратор'
        case this.roles.REGISTRAR:
          return 'Оператор'
        case this.roles.ADMIN_SIGN:
          return 'Администратор проверки подписей'
        case this.roles.REGISTRAR_SIGN:
          return 'Проверка подписей'
      }
    },
    clickHandler(item) {
      this.$emit('open-block-modal', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.cell-text {
  font-size: 14px;
  color: #333;
  &-normal {
    font-weight: 400;
  }
  &-bold {
    font-weight: 600;
  }
  &-link {
    color: #ff0000;
  }
  &-link:hover {
    cursor: pointer;
  }
}
</style>
